import React from 'react';
import { FormControl, InputLabel, OutlinedInput, InputAdornment, TextField, IconButton } from '@mui/material';
import "./styles.scss";
import Grid from "@mui/material/Grid2";
import CloseIcon from '@mui/icons-material/Close';


interface Props {
  label: string;
  value: string | null;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClear?: () => void;
}

export const DateInputLeftLabel = ({ label, value, onChange, onClear }: Props) => (
  <Grid  className="date-form-control">
    <InputLabel className="date-label-left">{label}</InputLabel>
    <TextField
      type="date"
      variant="outlined"
      size='small'
      fullWidth
      className="operations-date"
      value={value}
      onChange={onChange}
    />
    {onClear && value && (
        <IconButton
          size="small"
          color="error"
          onClick={() => onClear()}
        >
          <CloseIcon />
        </IconButton>
      )}
  </Grid>
)